import React from 'react';

export const useChildrenWithProps = (children, propsCallback = () => ({})) => {
  return React.useCallback(
    React.Children.map(children, (child, index) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          ...propsCallback(child),
          index,
        });
      }
      return child;
    }),
    [children, propsCallback]
  );
};
